import React, { useState } from 'react';
import { BaseURL } from '../../../constants/constants';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import {
  Button,
  Box,
  Divider,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Tabs,
  Tab,
  Toolbar,
  Tooltip,
  IconButton,
  OutlinedInput,
  InputAdornment
} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import * as XLSX from 'xlsx';
import descargar from '../../../assets/descargar.png';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SearchIcon from '@material-ui/icons/Search';
import GetAppIcon from '@material-ui/icons/GetApp';
import { encryptData } from '../../../utils/CryptoHandler';

const useStyles = makeStyles(theme => ({
  title: {
    flex: '1 1 100%',
  },
  titleChart: {
    fontWeight: 'bold'
  },
  verticalDivider: {
    margin: theme.spacing(0, 2),
    height: 50,
    backgroundColor: "black",
    width: 2,
  },
  paperMenu: {
    flexGrow: 1,
    background: "transparent",
    boxShadow: 'none'
  },
  tab: {
    minWidth: 200,
    marginRight: theme.spacing(4),
    '&:last-child': {
      marginRight: 0
    }
  },
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight: theme.palette.type === 'light' ? {
    color: theme.palette.secondary.main,
  } : {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.secondary.dark,
  },
}));

export default function Graph(props) {
  const [actualSite, setActualSite] = useState(1);
  const [dataDetail, setDataDetail] = useState([]);
  const classes = useStyles();

  const [historicalTx, setHistoricalTx] = React.useState([]);
  const [individualLinks, setIndividualLink] = React.useState([]);
  const [typeSearch, setTypeSearch] = React.useState(0);
  const [searchText, setSearchText] = useState('');

  // Estados de paginación separados
  const [pageFile, setPageFile] = React.useState(0);
  const [pageDetail, setPageDetail] = React.useState(0);
  const [pageIndividual, setPageIndividual] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  React.useEffect(() => {
    const fetchData = async () => {
      if (typeSearch === 0 && historicalTx.length === 0) {
        await getHistoricalTxFile(props.nombre_usuario);
      }
      if (typeSearch === 2) {
        await getHistoricalIndividualLinks(props.nombre_usuario);
      }
    };
    fetchData();
  }, [typeSearch]);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    // Reiniciar todas las páginas al cambiar el tamaño
    setPageFile(0);
    setPageDetail(0);
    setPageIndividual(0);
  };

  const getHistoricalTxFile = async (nombre_usuario) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_URL + process.env.REACT_APP_GET_HISTORICAL_TX_FILE,
        { user_plink: nombre_usuario },
        {
          headers: {
            'Authorization': `Bearer ${encryptData(props.token, process.env.REACT_APP_LOGIN_KEY)}`,
            'id_commerce': encryptData(props.id_commerce, process.env.REACT_APP_LOGIN_KEY)
          }
        }
      );
      if (response.data.exito && response.data.data.length > 0) {
        setIndividualLink([]);
        setHistoricalTx(response.data.data);
      }
    } catch (error) {
      console.error('Error al obtener los datos históricos:', error);
    }
  }

  const getHistoricalIndividualLinks = async (nombre_usuario) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_URL + process.env.REACT_APP_GET_HISTORICAL_INDIVIDUAL_LINK,
        { user_plink: nombre_usuario },
        {
          headers: {
            'Authorization': `Bearer ${encryptData(props.token, process.env.REACT_APP_LOGIN_KEY)}`,
            'id_commerce': encryptData(props.id_commerce, process.env.REACT_APP_LOGIN_KEY)
          }
        }
      );
      if (response.data.exito) {
        setHistoricalTx([]);
        setIndividualLink(response.data.data);
      }
    } catch (error) {
      console.error('Error al obtener los datos históricos:', error);
    }
  }

  const FileTable = (props) => {
    const {
      historicalTx,
      nombre_usuario,
      searchText,
      actualSite,
      setActualSite,
      dataDetail,
      setDataDetail,
      pageFile,
      setPageFile,
      pageDetail,
      setPageDetail,
      rowsPerPage
    } = props;

    const columns = [
      { id: 'fecha', label: 'Fecha', minWidth: 170, align: 'center' },
      { id: 'nombre_campana', label: 'Nombre campaña', minWidth: 170, align: 'center' },
      { id: 'nombre_archivo', label: 'Nombre archivo', minWidth: 170, align: 'center' },
      { id: 'numeros_de_links', label: 'Numero de links', minWidth: 170, align: 'center' },
      { id: 'estatus', label: 'Estatus', minWidth: 170, align: 'center' },
      { id: 'id_archivo', label: 'Ver', minWidth: 80, align: 'center' }
    ];

    const columsDetail = [
      { id: 'nombre_persona', label: 'Nombre', minWidth: 170, align: 'center' },
      { id: 'cedula_persona', label: 'Cédula', minWidth: 170, align: 'center' },
      { id: 'correo_persona', label: 'Correo', minWidth: 170, align: 'center' },
      { id: 'referencia', label: 'Referencia', minWidth: 170, align: 'center' },
      { id: 'telefono_persona', label: 'Teléfono', minWidth: 170, align: 'center' },
      { id: 'concepto', label: 'Concepto', minWidth: 170, align: 'center' },
      { id: 'monto', label: 'Monto Bs.', minWidth: 170, align: 'center' },
      { id: 'status_detail', label: 'Estatus Link', minWidth: 170, align: 'center' },
      { id: 'transaction_status', label: 'Estatus de transacción', minWidth: 170, align: 'center' }
    ];

    const handleChangePageFile = (event, newPage) => {
      setPageFile(newPage);
    };

    const handleChangePageDetail = (event, newPage) => {
      setPageDetail(newPage);
    };

    const getDetailFile = async (id_archivo) => {
      try {
        const response = await axios.post(
          process.env.REACT_APP_URL + process.env.REACT_APP_DETAIL_FILE,
          { id_archivo: id_archivo, usuario_plink: nombre_usuario },
          {
            headers: {
              'Authorization': `Bearer ${encryptData(props.token, process.env.REACT_APP_LOGIN_KEY)}`,
              'id_commerce': encryptData(props.id_commerce, process.env.REACT_APP_LOGIN_KEY)
            }
          }
        );
        if (response.data.exito) {
          setSearchText("");
          setActualSite(2);
          setDataDetail(response.data.data);
          setPageDetail(0); // Reiniciar página de detalle
        }
      } catch (error) {
        console.error('Error al obtener los datos históricos:', error);
      }
    }

    const handleDetail = async (value) => {
      try {
        await getDetailFile(value);
      } catch (error) {
        console.error('Error al obtener detalle:', error);
      }
    };

    return (
      <Paper className={classes.root}>
        {actualSite === 1 ? (
          <>
            <TableContainer className={classes.container}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {historicalTx
                    .filter(row => {
                      const search = searchText.toLowerCase();
                      return (
                        (!searchText) ||
                        (row.fecha && new Date(row.fecha).toLocaleString('es-ES', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true }).toLowerCase().includes(search)) ||
                        (row.nombre_campana && row.nombre_campana.toLowerCase().includes(search)) ||
                        (row.nombre_archivo && row.nombre_archivo.toLowerCase().includes(search)) ||
                        (row.numeros_de_links && row.numeros_de_links.toString().toLowerCase().includes(search)) ||
                        (row.estatus && row.estatus.toLowerCase().includes(search))
                      );
                    })
                    .slice(pageFile * rowsPerPage, pageFile * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      return (
                        <TableRow hover role="checkbox" tabIndex={-1} key={row.nombre_archivo}>
                          {columns.map((column) => {
                            let value = row[column.id];
                            if (column.id === 'fecha') {
                              value = new Date(value).toLocaleString('es-ES', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true });
                            }
                            return (
                              <TableCell style={{ border: 'none' }} key={column.id} align={column.align}>
                                {column.id === 'id_archivo'
                                  ? <VisibilityIcon onClick={() => handleDetail(value)} />
                                  : value
                                }
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={historicalTx.length}
              rowsPerPage={rowsPerPage}
              page={pageFile}
              onChangePage={handleChangePageFile}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              labelRowsPerPage="Filas por página:"
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
            />
          </>
        ) : (
          <>
            <Box id="barra_busqueda2" display="flex" alignItems="center" width="100%" style={{ gap: 20, padding: 24 }}>
              <Button
                id="button-back_principal_table"
                variant="outlined"
                color="primary"
                startIcon={<ArrowBackIcon />}
                onClick={() => {
                  setActualSite(1);
                  setSearchText("");
                  setPageFile(0); // Reiniciar página principal
                }}
                style={{
                  height: 36,
                  minWidth: 80,
                  fontWeight: 600,
                  fontSize: 14,
                  whiteSpace: "nowrap",
                  border: "none",
                  boxShadow: "none",
                  background: "none"
                }}
              />
            </Box>
            <TableContainer className={classes.container}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {columsDetail.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataDetail && dataDetail.filter(row => {
                    const search = searchText.toLowerCase();
                    return (
                      (!searchText) ||
                      (row.nombre_persona && row.nombre_persona.toLowerCase().includes(search)) ||
                      (row.cedula_persona && row.cedula_persona.toLowerCase().includes(search)) ||
                      (row.correo_persona && row.correo_persona.toString().toLowerCase().includes(search)) ||
                      (row.referencia && row.referencia.toLowerCase().includes(search)) ||
                      (row.telefono_persona && row.telefono_persona.toString().toLowerCase().includes(search)) ||
                      (row.concepto && row.concepto.toLowerCase().includes(search)) ||
                      (row.monto && row.monto.toString().toLowerCase().includes(search)) ||
                      (row.status_detail && row.status_detail.toLowerCase().includes(search)) ||
                      (row.transaction_status && row.transaction_status === 1 ? "Completado" : row.transaction_status === 2 ? "Rechazado" : "Pendiente").toLowerCase().includes(search)
                    );
                  }).slice(pageDetail * rowsPerPage, pageDetail * rowsPerPage + rowsPerPage).map((row) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={row.id_token}>
                        {columsDetail.map((column) => {
                          let value = row[column.id];
                          if (column.id === 'monto') {
                            value = parseFloat(value).toFixed(2);
                          }
                          if (column.id === 'transaction_status') {
                            if (value === 1) value = "Completado";
                            if (value === 2) value = "Rechazado";
                            if (value === null) value = "Pendiente";
                          }
                          return (
                            <TableCell style={{ border: 'none' }} key={column.id} align={column.align}>
                              {value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={dataDetail.length}
              rowsPerPage={rowsPerPage}
              page={pageDetail}
              onChangePage={handleChangePageDetail}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              labelRowsPerPage="Filas por página:"
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
            />
          </>
        )}
      </Paper>
    );
  }

  const IndividualTable = (props) => {
    const {
      individualLinks,
      searchText,
      pageIndividual,
      setPageIndividual,
      rowsPerPage
    } = props;

    const columns = [
      { id: 'fecha_creacion_min', label: 'Fecha', minWidth: 300, align: 'center' },
      { id: 'num_referencia', label: 'Referencia', minWidth: 170, align: 'center' },
      { id: 'canal', label: 'Canal de envío', minWidth: 170, align: 'center' },
      { id: 'monto', label: 'Monto Bs.', minWidth: 170, align: 'center' },
      { id: 'motivo', label: 'Concepto', minWidth: 170, align: 'center' },
      { id: 'estatus', label: 'Estatus', minWidth: 170, align: 'center' },

      { id: 'correo', label: 'Correo enviado', minWidth: 80, align: 'center' },
      { id: 'estatus_token', label: 'Estatus Link', minWidth: 170, align: 'center' }
    ];

    const handleChangePageIndividual = (event, newPage) => {
      setPageIndividual(newPage);
    };

    return (
      <Paper className={classes.root}>
        <TableContainer className={classes.containerIndividual}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {individualLinks
                .filter(row => {
                  const search = searchText.toLowerCase();
                  return (
                    (!searchText) ||
                    (row.fecha_creacion_min && new Date(row.fecha_creacion_min).toLocaleString('es-ES', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true }).toLowerCase().includes(search)) ||
                    (row.num_referencia && row.num_referencia.toString().toLowerCase().includes(search)) ||
                    (row.canal && (
                      (row.canal === 1 && 'correo electrónico'.includes(search)) ||
                      (row.canal === 2 && 'whatsapp'.includes(search)) ||
                      (typeof row.canal === 'string' && row.canal.toLowerCase().includes(search))
                    )) ||
                    (row.monto && row.monto.toString().toLowerCase().includes(search)) ||
                    (row.motivo && row.motivo.toLowerCase().includes(search)) ||
                    (row.estatus && (
                      (row.estatus === 1 && 'aprobado'.includes(search)) ||
                      (row.estatus === 2 && 'rechazado'.includes(search)) ||
                      (row.estatus === null && 'pendiente'.includes(search)) ||
                      (typeof row.estatus === 'string' && row.estatus.toLowerCase().includes(search))
                    )) ||
                    (row.correo && row.correo.toLowerCase().includes(search)) ||
                    (row.estatus_token && row.estatus_token.toLowerCase().includes(search))
                  );
                })
                .slice(pageIndividual * rowsPerPage, pageIndividual * rowsPerPage + rowsPerPage)
                .map((row) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.nombre_archivo}>
                      {columns.map((column) => {
                        let value = row[column.id];
                        if (column.id === 'canal' && value === 1) value = 'Correo electrónico';
                        if (column.id === 'canal' && value === 2) value = 'Whatsapp';
                        if (column.id === 'estatus' && value === 1) value = 'Aprobada';
                        if (column.id === 'estatus' && value === 2) value = 'Rechazada';
                        if (column.id === 'estatus' && value === null) value = 'Pendiente';
                        if (column.id === 'fecha_creacion_min') {
                          value = new Date(value).toLocaleString('es-ES', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true });
                        }
                        return (
                          <TableCell style={{ border: 'none' }} key={column.id} align={column.align}>
                            {value}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={individualLinks.length}
          rowsPerPage={rowsPerPage}
          page={pageIndividual}
          onChangePage={handleChangePageIndividual}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          labelRowsPerPage="Filas por página:"
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
        />
      </Paper>
    );
  }

  const handleChangeTab = (event, newValue) => {
    setTypeSearch(newValue);
    // Reiniciar todas las páginas al cambiar de pestaña
    setPageFile(0);
    setPageDetail(0);
    setPageIndividual(0);
  };

  const onExport = () => {
    let dataToExport = [];
    let fileName = '';

    // Determinar qué datos exportar según la vista actual
    if (typeSearch === 0) {
      if (actualSite === 1) {
        // Vista de archivos masivos
        dataToExport = historicalTx.filter(row => {
          const search = searchText.toLowerCase();
          return (
            (!searchText) ||
            (row.fecha && new Date(row.fecha).toLocaleString('es-ES', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true }).toLowerCase().includes(search)) ||
            (row.nombre_campana && row.nombre_campana.toLowerCase().includes(search)) ||
            (row.nombre_archivo && row.nombre_archivo.toLowerCase().includes(search)) ||
            (row.numeros_de_links && row.numeros_de_links.toString().toLowerCase().includes(search)) ||
            (row.estatus && row.estatus.toLowerCase().includes(search)) ||
            (row.correo && row.correo.toLowerCase().includes(search)) ||
            (row.estatus_token && row.estatus_token.toLowerCase().includes(search))
          );
        });
        fileName = 'Enlaces_Masivos';
      } else {
        // Vista de detalle de archivo masivo
        dataToExport = dataDetail.filter(row => {
          const search = searchText.toLowerCase();
          return (
            (!searchText) ||
            (row.nombre_persona && row.nombre_persona.toLowerCase().includes(search)) ||
            (row.cedula_persona && row.cedula_persona.toLowerCase().includes(search)) ||
            (row.correo_persona && row.correo_persona.toString().toLowerCase().includes(search)) ||
            (row.referencia && row.referencia.toLowerCase().includes(search)) ||
            (row.telefono_persona && row.telefono_persona.toString().toLowerCase().includes(search)) ||
            (row.concepto && row.concepto.toLowerCase().includes(search)) ||
            (row.monto && row.monto.toString().toLowerCase().includes(search)) ||
            (row.status_detail && row.status_detail.toLowerCase().includes(search)) ||
            (row.transaction_status && (row.transaction_status === 1 ? "Completado" : row.transaction_status === 2 ? "Rechazado" : "Pendiente").toLowerCase().includes(search))
          );
        });
        fileName = 'Detalle_Enlaces_Masivos';
      }
    } else {
      // Vista de enlaces individuales
      dataToExport = individualLinks.filter(row => {
        const search = searchText.toLowerCase();
        return (
          (!searchText) ||
          (row.fecha_creacion_min && new Date(row.fecha_creacion_min).toLocaleString('es-ES', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true }).toLowerCase().includes(search)) ||
          (row.num_referencia && row.num_referencia.toString().toLowerCase().includes(search)) ||
          (row.canal && (
            (row.canal === 1 && 'correo electrónico'.includes(search)) ||
            (row.canal === 2 && 'whatsapp'.includes(search)) ||
            (typeof row.canal === 'string' && row.canal.toLowerCase().includes(search))
          )) ||
          (row.monto && row.monto.toString().toLowerCase().includes(search)) ||
          (row.motivo && row.motivo.toLowerCase().includes(search)) ||
          (row.estatus && (
            (row.estatus === 1 && 'aprobado'.includes(search)) ||
            (row.estatus === 2 && 'rechazado'.includes(search)) ||
            (row.estatus === null && 'pendiente'.includes(search)) ||
            (typeof row.estatus === 'string' && row.estatus.toLowerCase().includes(search))
          )) ||
          (row.correo && row.correo.toLowerCase().includes(search)) ||
          (row.estatus_token && row.estatus_token.toLowerCase().includes(search))
        );
      });
      fileName = 'Enlaces_Individuales';
    }

    // Verificar si hay datos para exportar
    if (dataToExport.length === 0) {
      alert('No hay datos para exportar');
      return;
    }

    try {
      // Crear libro de trabajo y hoja
      const wb = XLSX.utils.book_new();

      // Preparar los datos para la hoja de cálculo
      const wsData = [];

      // Agregar encabezados
      if (typeSearch === 0 && actualSite === 1) {
        // Encabezados para archivos masivos
        wsData.push([
          'Fecha',
          'Nombre campaña',
          'Nombre archivo',
          'Número de links',
          'Estatus'
        ]);

        // Agregar datos
        dataToExport.forEach(row => {
          wsData.push([
            new Date(row.fecha).toLocaleString('es-ES', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true }),
            row.nombre_campana,
            row.nombre_archivo,
            row.numeros_de_links,
            row.estatus
          ]);
        });
      }
      else if (typeSearch === 0 && actualSite === 2) {
        // Encabezados para detalle de archivo masivo
        wsData.push([
          'Nombre',
          'Cédula',
          'Correo',
          'Referencia',
          'Teléfono',
          'Concepto',
          'Monto Bs.',
          'Estatus Link',
          'Estatus Transacción'
        ]);

        // Agregar datos
        dataToExport.forEach(row => {
          wsData.push([
            row.nombre_persona,
            row.cedula_persona,
            row.correo_persona,
            row.referencia,
            row.telefono_persona,
            row.concepto,
            parseFloat(row.monto).toFixed(2),
            row.status_detail,
            row.transaction_status === 1 ? "Completado" :
              row.transaction_status === 2 ? "Rechazado" : "Pendiente"
          ]);
        });
      }
      else {
        // Encabezados para enlaces individuales
        wsData.push([
          'Fecha',
          'Referencia',
          'Canal de envío',
          'Monto Bs.',
          'Concepto',
          'Estatus',
          'Correo',
          'Estatus Link'
        ]);

        // Agregar datos
        dataToExport.forEach(row => {
          wsData.push([
            new Date(row.fecha_creacion_min).toLocaleString('es-ES', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true }),
            row.num_referencia,
            row.canal === 1 ? 'Correo electrónico' : row.canal === 2 ? 'Whatsapp' : row.canal,
            parseFloat(row.monto).toFixed(2),
            row.motivo,
            row.estatus === 1 ? 'Aprobada' :
              row.estatus === 2 ? 'Rechazada' : 'Pendiente',
            row.correo,
            row.estatus_token
          ]);
        });
      }

      // Crear hoja de cálculo
      const ws = XLSX.utils.aoa_to_sheet(wsData);

      // Agregar hoja al libro
      XLSX.utils.book_append_sheet(wb, ws, fileName);

      // Generar nombre de archivo con fecha
      const today = new Date();
      const formattedDate = `${today.getDate()}-${today.getMonth() + 1}-${today.getFullYear()}`;
      const fullFileName = `${fileName}_${formattedDate}.xlsx`;

      // Descargar archivo
      XLSX.writeFile(wb, fullFileName);

    } catch (error) {
      console.error('Error al exportar a Excel:', error);
      alert('Ocurrió un error al generar el archivo Excel');
    }
  };
  return (
    <React.Fragment>
      <Box p={3} maxWidth="100%">
        <Box mt={2}>
          <Paper className={classes.paperMenu}>
            <Tabs
              value={typeSearch}
              onChange={handleChangeTab}
              indicatorColor="primary"
              textColor="black"
              centered
            >
              <Tab label="Enlaces masivos" className={classes.tab} />
              <Divider
                orientation="vertical"
                flexItem
                className={classes.verticalDivider}
              />
              <Tab label="Enlaces individuales" className={classes.tab} />
            </Tabs>
          </Paper>

          <Box id="barra_busqueda" display="flex" alignItems="center" width="100%" style={{ gap: 20, padding: 24 }}>
            <Typography variant="h6" style={{ fontWeight: 700, marginRight: 32, whiteSpace: "nowrap" }}>
              Buscar
            </Typography>
            <OutlinedInput
              id="search-input"
              placeholder="Filtra tus enlaces enviados por cualquier campo"
              variant="outlined"
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
              startAdornment={
                <InputAdornment position="start">
                  <SearchIcon style={{ color: "#bbb" }} />
                </InputAdornment>
              }
              style={{ height: 36, fontSize: 15, width: "100%" }}
            />
            <Button
              variant="contained"
              color="primary"
              startIcon={<GetAppIcon />}
              style={{
                height: 36,
                minWidth: 180,
                fontWeight: 600,
                fontSize: 12,
                whiteSpace: "nowrap"
              }}
              onClick={onExport}
            >
              DESCARGAR EXCEL
            </Button>
          </Box>

          {typeSearch === 0 ? (
            <FileTable
              historicalTx={historicalTx}
              nombre_usuario={props.nombre_usuario}
              searchText={searchText}
              actualSite={actualSite}
              setActualSite={setActualSite}
              dataDetail={dataDetail}
              setDataDetail={setDataDetail}
              pageFile={pageFile}
              setPageFile={setPageFile}
              pageDetail={pageDetail}
              setPageDetail={setPageDetail}
              rowsPerPage={rowsPerPage}
              token={props.token}
              id_commerce={props.id_commerce}
            />
          ) : (
            <IndividualTable
              individualLinks={individualLinks}
              searchText={searchText}
              pageIndividual={pageIndividual}
              setPageIndividual={setPageIndividual}
              rowsPerPage={rowsPerPage}
              token={props.token}
              id_commerce={props.id_commerce}
            />
          )}
        </Box>
      </Box>
    </React.Fragment>
  );
}